




























import {Vue, Component, Prop, Watch, PropSync} from 'vue-property-decorator';
import ClickOutside from 'vue-click-outside';
import {GetMallsContractedPartnersByMallNoRequest} from 'supporter';

// TODO: 기존 코드 리팩토링
@Component({
  directives: {
    ClickOutside
  }
})
export default class PartnerInput extends Vue{
  @Prop({ required: true})
  private mallNo! : undefined | number
  @PropSync('partnerNo')
  private partnerNoSync!: string

  private parterInputVal = ''
  private parterData = []
  private selectedIdx = -1;
  private showSearch: boolean = false;
  private parterSearchResult: any[] = [];

  @Watch('parterInputVal', {immediate: true, deep: true})
  onInputValChange() {
    this.$nextTick(() => {
      this.dataFilter();
    });
  }
  @Watch('parterData', {immediate: true, deep: true})
  parterDataChange() {
    this.$nextTick(() => {
      this.dataFilter();
    });
  }

  private itemClick(item: any) {
    if (item.value !== '0') {
      this.showSearch = false;
      this.parterInputVal = item.text;
      this.partnerNoSync = item.value;
    }
  }

  private pressDown() {
    if (this.selectedIdx < this.parterSearchResult.length - 1) {
      this.selectedIdx++;
    } else {
      this.selectedIdx = 0;
    }
  }

  private pressUp() {
    if (this.selectedIdx === 0 || this.selectedIdx === -1) {
      this.selectedIdx = this.parterSearchResult.length - 1;
    } else {
      this.selectedIdx--;
    }
  }

  private pressEnter() {
    if (this.selectedIdx === -1) {
      return;
    }
    const result = this.parterSearchResult[this.selectedIdx];
    if (result.value !== '0') {
      this.showSearch = false;
      this.partnerNoSync = result.value;
      this.parterInputVal = result.text;
      this.selectedIdx = -1;
    }
  }

  private handleParterSearch(e: InputEvent) {
    this.parterInputVal = (e.target as HTMLInputElement).value; // vue에서 한글 사용시 마지막 글자는 안먹히는데, 이를 해결하기 코드
    if (this.parterData.length === 0) {
      let parterRequest: GetMallsContractedPartnersByMallNoRequest = {
        pathParams: {
          mallNo: this.mallNo.toString()
        }
      };
      this.$api
        .getMallsContractedPartnersByMallNo(parterRequest)
        .then(({data}): any => {
          this.parterData = data.filter(item => {
            return item.partnerStatus === 'ACTIVE' && ( item.contractStatus === 'ACTIVE' || item.contractStatus === 'SUSPEND' );
          });
          this.showSearch = true;
        })
        .finally((): any => {

        });
    } else {
      this.showSearch = true;
    }
  }

  private resetPartner(): void {
    this.parterInputVal = '';
    this.partnerNoSync = null;
  }
  private outsideClick(): void {
    this.showSearch = false;
  }
  private handleSearchBlur(): void {
    if (this.parterData.length && this.parterInputVal.length) {
      if (!this.parterData.find((item: any): any => item.partnerName === this.parterInputVal)) {
        this.parterInputVal = '';
        this.partnerNoSync = null;
      }
    }
  }

  private dataFilter(): void {
    if (this.parterInputVal.length > 0) {
      const regexp = new RegExp(this.parterInputVal.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1'), 'gi');
      const result = this.parterData.filter((item: any) => {
        return item.partnerName.match(regexp);
      });
      if (result.length) {
        this.parterSearchResult = result.map((list) => {
          return {
            text: list.partnerName,
            value: list.partnerNo,
            label: list.partnerName.replace(regexp, '<span>$&</span>')
          };
        });
      } else {
        let noSearchText: any = this.$t('ORDER_ORDER_CONTENT_TOP_PARTNER_SEARCH_NO_LABEL');
        this.parterSearchResult = [{value: '0', label: noSearchText, text: ''}];
      }
    } else {
      let noSearchText: any = this.$t('ORDER_ORDER_CONTENT_TOP_PARTNER_SEARCH_NO_LABEL');
      this.parterSearchResult = [{value: '0', label: noSearchText, text: ''}];
    }
  }
}
